<!-- <div class="account-pages my-5 pt-sm-5 bg-color"> -->
<div class="account-pages py-4 auth-layout bg-color">
    <div class="container centered-div ">
        <div class="row justify-content-center gutter-x-0">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="">
                    <div class="row gutter-x-0">
                        <div class="col-12 text-center">
                            <a routerLink="/">
                                <img src="assets/images/identity/logo-white.svg" alt="" class="img-fluid logo-auth">
                            </a>
                        </div>
                    </div>
                </div>
                
                <div class="card overflow-hidden">
                    <div class="card-body pt-4">
                        <router-outlet />
                    </div>
                </div>

                <div class="">
                    <div class="text-center d-flex">
                        <div class="mx-auto">
                            <span class="auth-footer-text">
                                <img src="assets/images/identity/ssl.svg" class='mr-3px' height="20"> 
                                {{"AUTH.ssl" | translate}}
                            </span>
                            <span class="auth-footer-text ml-20px">
                                <img src="assets/images/identity/2fa.svg" class='mr-3px' height="20"> 
                                {{"AUTH.2fa" | translate}}
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>